import React, { useEffect, useState } from 'react';
import { Container, Card, CardContent, Typography, Button, LinearProgress } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useParams } from 'react-router-dom';
import { doSwaggerCall } from '../hooks/useSwaggerClient';
import { buildManifestReport, downloadManifestWorkbook } from '../manifestReport';

// Public, login-free manifest download — the page the vendor manifest email
// links to, in place of the attachment it used to carry. The hash is the
// credential; the .xlsx is built here, in the browser.
export default function ManifestReportPage() {
    const { id, start, hash } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const res = await doSwaggerCall('activities', 'getManifestReportByHash', {
                    activityId: Number(id),
                    activity_start: start,
                    hash
                });
                if (!cancelled) {
                    setData(res);
                }
            } catch (err) {
                if (!cancelled) {
                    setFailed(true);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [id, start, hash]);

    const onDownload = () => {
        const activity = data?.generalDatas?.activity;
        const guests = data?.guests || [];
        if (!guests.length) {
            return;
        }
        downloadManifestWorkbook(
            buildManifestReport(activity?.start || start, activity?.end, guests),
            `${activity?.name || 'manifest'}-${start}`
        );
    };

    const activityName = data?.generalDatas?.activity?.name || '';

    return (
        <Container maxWidth="sm" style={{ marginTop: 40 }}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Manifest report
                    </Typography>
                    {loading && <LinearProgress />}
                    {!loading && failed && (
                        <Typography color="error">
                            This manifest link is no longer valid. Ask for a new one.
                        </Typography>
                    )}
                    {!loading && !failed && (
                        <>
                            <Typography gutterBottom>
                                Download the manifest for {activityName} on {start}.
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<GetAppIcon />}
                                onClick={onDownload}
                            >
                                Download the manifest
                            </Button>
                        </>
                    )}
                </CardContent>
            </Card>
        </Container>
    );
}
